module.exports = __webpack_public_path__ + "img/pol.6d795bc6.svg";